module.exports = __webpack_public_path__ + "img/study_icon.b7adc066.png";